import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideNgIconsConfig } from '@ng-icons/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import player from 'lottie-web';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';

import { INTERCEPTORS_HTTP } from './app.interceptors';
import { routes } from './app.routes';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '-0300' } },
    // CDK 21 passou a renderizar overlays como popover na top-layer por padrão
    // (usePopover: true), o que quebra o `overlayOutsideClick` — o dropdown do
    // app-select, o kebab de ações, etc. não fechavam ao clicar fora (#769).
    // Voltamos ao overlay clássico, onde o outside-click é confiável.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideNgIconsConfig({
      size: '1.5em',
      color: '#C11718',
    }),
    provideLottieOptions({ player: () => player }),
    provideCacheableAnimationLoader(),
    importProvidersFrom(BrowserModule),
    provideAnimations(),
    // A ordem dos interceptors importa e é testada em `app.interceptors.spec.ts`.
    provideHttpClient(withInterceptors(INTERCEPTORS_HTTP)),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
      fallbackLang: 'pt-BR',
    }),
    provideRouter(routes, withViewTransitions()),
  ],
};
